export default "__VITE_ASSET__CwfS3$_u__"